import React, { useState, useEffect } from "react";
import boardBackground1 from "assets/backgrounds/ortivis/chenove.png";
import boardBackground2 from "assets/backgrounds/ortivis/beaune.png";
import boardBackground3 from "assets/backgrounds/ortivis/chevigny_saint_sauveur.png";
import boardBackground4 from "assets/backgrounds/ortivis/montbard.png";
import boardBackground5 from "assets/backgrounds/ortivis/dijon.png";
import clouds from "assets/backgrounds/ortivis/nuages.png";
import road from "assets/backgrounds/ortivis/road.png";

import dog1 from "assets/backgrounds/ortivis/dog/chien_1.png";
import dog2 from "assets/backgrounds/ortivis/dog/chien_2.png";
import dog3 from "assets/backgrounds/ortivis/dog/chien_3.png";
import dog4 from "assets/backgrounds/ortivis/dog/chien_4.png";
import dog5 from "assets/backgrounds/ortivis/dog/chien_5.png";
import dog6 from "assets/backgrounds/ortivis/dog/chien_6.png";

import "./OrtivisBoardGame.css";

const BASE_WORLDS = [
	boardBackground1,
	boardBackground2,
	boardBackground3,
	boardBackground4,
];

const DOG_FRAMES = [dog1, dog2, dog3, dog4, dog5, dog6];

const ASPECT_RATIO = 1077 / 606;
const REM_TO_PX = 16;
const CELL_WIDTH = 3 * REM_TO_PX;
const GAP_WIDTH = 2.2 * REM_TO_PX;
const CONTAINER_PADDING = 1.5 * 2 * REM_TO_PX;

const generateClouds = (worldWidth, screenHeight, amount) => {
	return Array.from({ length: amount }, (_, index) => ({
		id: Math.random(),
		left: (index + 1) * worldWidth * Math.abs(Math.random()), // Distribute evenly across the world width
		top: Math.random() * screenHeight * 0.2, // Only in the top half
		speed: 500 + Math.random() * 500, // Random speed between 5s and 10s per full loop
	}));
};

const BoardBackground = ({ boardCasesLength, screenHeight }) => {
	const [worldWidth, setWorldWidth] = useState(0);
	const [worlds, setWorlds] = useState([]);
	const [cloudsData, setCloudsData] = useState([]);
	const [dogFrame, setDogFrame] = useState(0);
	const [dogPosition, setDogPosition] = useState({ x: -500, y: -800 });

	useEffect(() => {
		const calculatedWorldWidth = Math.round(screenHeight * ASPECT_RATIO);
		setWorldWidth(calculatedWorldWidth);
	}, [screenHeight]);

	useEffect(() => {
		if (worldWidth > 0) {
			const totalBoardWidth =
				boardCasesLength * (CELL_WIDTH + GAP_WIDTH) + CONTAINER_PADDING;
			const requiredWorlds = Math.ceil(totalBoardWidth / worldWidth);
			setWorlds([...Array(requiredWorlds - 1)].map((_, i) => i));
			setCloudsData(generateClouds(worldWidth, screenHeight, requiredWorlds));
		}
	}, [boardCasesLength, worldWidth]);

	// Animate dog frame
	useEffect(() => {
		const interval = setInterval(() => {
			setDogFrame((prev) => (prev + 1) % DOG_FRAMES.length);
		}, 200);
		return () => clearInterval(interval);
	}, []);

	return (
		<div className="relative flex h-screen w-max bg-gradient-to-br from-blue-400 via-cyan-300 to-orange-400">
			<div className="absolute top-0 left-0 w-full h-full bg-cover overflow-hidden">
				{/* Cloud Layer */}
				{cloudsData.map((cloud) => (
					<>
						<img
							key={cloud.id}
							src={clouds}
							alt="cloud"
							className="absolute opacity-100 "
							style={{
								height: "600px",
								left: cloud.left,
								top: cloud.top,
								animation: `moveCloud ${cloud.speed}s linear infinite`,
							}}
						/>
					</>
				))}
			</div>
			{/* World Backgrounds */}
			{worlds.map((worldIndex) => (
				<div
					key={worldIndex}
					className="relative"
					style={{ width: worldWidth, height: screenHeight }}
				>
					<img
						alt={`world-${worldIndex}`}
						src={BASE_WORLDS[worldIndex % BASE_WORLDS.length]}
						className="h-full w-full object-cover"
					/>
					<img
						alt={`road-${worldIndex}`}
						src={road}
						className="absolute top-0 left-0 h-full w-full object-cover"
					/>
				</div>
			))}
			<div
				className="relative"
				style={{ width: worldWidth, height: screenHeight }}
			>
				<img
					alt={`world-dijon`}
					src={boardBackground5}
					className="h-full w-full object-cover"
				/>
				<img
					alt={`road-dijon`}
					src={road}
					className="absolute top-0 left-0 h-full w-full object-cover"
				/>
			</div>

			<div className="absolute top-0 left-0 w-full h-full bg-cover overflow-hidden">
				<img
					src={DOG_FRAMES[dogFrame]}
					alt="dog"
					className="absolute w-24 h-24"
					style={{
						left: `${dogPosition.x}px`,
						top: `${screenHeight - 100}px`,
						transition: "right 0.2s, top 0.2s",
						animation: `moveDog ${180}s linear infinite`,
					}}
				/>
			</div>
		</div>
	);
};

export default BoardBackground;
